module.exports = __webpack_public_path__ + "static/media/Spin.0e7fa9a7.svg";